import bodyLightDefault from './body/light-default.svg?raw'
import circleBlueBackground from './background/circle-blue-01.svg?raw'
import noseDefault from './face/nose/default.svg?raw'
import { topComponents, type TopComponentName } from './top/generated'
import {
  accessoryComponents,
  type AccessoryComponentName,
} from './accessories/generated'
import {
  facialHairComponents,
  type FacialHairComponentName,
} from './face/facial-hair/generated'
import {
  clothingComponents,
  type ClothingComponentName,
} from './clothing/generated'
import {
  clothingGraphicComponents,
  type ClothingGraphicComponentName,
} from './clothing/graphics/generated'
import {
  eyesComponents,
  type EyesComponentName,
} from './face/eyes/generated'
import {
  eyebrowsComponents,
  type EyebrowsComponentName,
} from './face/eyebrows/generated'
import {
  mouthComponents,
  type MouthComponentName,
} from './face/mouth/generated'

export const avatarComponentCatalog = {
  body: {
    lightDefault: bodyLightDefault,
  },
  background: {
    circleBlue01: circleBlueBackground,
  },
  face: {
    eyes: eyesComponents,
    eyebrows: eyebrowsComponents,
    mouth: mouthComponents,
    nose: {
      default: noseDefault,
    },
  },
  clothing: clothingComponents,
  clothingGraphics: clothingGraphicComponents,
} as const

export type AvatarComponentCatalog = typeof avatarComponentCatalog

export const avatarTopComponents = topComponents

export type AvatarTopComponentName = TopComponentName

export const avatarAccessoryComponents = accessoryComponents

export type AvatarAccessoryComponentName = AccessoryComponentName

export const avatarFacialHairComponents = facialHairComponents

export type AvatarFacialHairComponentName = FacialHairComponentName

export const avatarClothingComponents = clothingComponents

export type AvatarClothingComponentName = ClothingComponentName

export const avatarClothingGraphicComponents = clothingGraphicComponents

export type AvatarClothingGraphicComponentName = ClothingGraphicComponentName

export const avatarEyesComponents = eyesComponents

export type AvatarEyesComponentName = EyesComponentName

export const avatarEyebrowComponents = eyebrowsComponents

export type AvatarEyebrowComponentName = EyebrowsComponentName

export const avatarMouthComponents = mouthComponents

export type AvatarMouthComponentName = MouthComponentName
